import { Search,AccountHeadDetails,AccountSubHeadDetails } from '../../shared/user.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { User } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-sub-head',
  templateUrl: './sub-head.component.html',
  styleUrls: ['./sub-head.component.css']
})
export class SubHeadComponent implements OnInit {

  maintitle="SubHead";

  title="Add Sub Account Head";
  accountHeads: any={};
  AccountSubHeadDetails : any={};
  AccountSubHead: any;
  AccountHead : any;
  mode: string;
  formSubmitted: boolean;

  constructor(private userService: RegistrationService,private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) { 
    
  }

  ngOnInit() {
    //this.GetAllRegion();
    this.route.params.subscribe(params => {
      this.mode = params['mode'];
      this.AccountHead = params["accountHead"];
      this.AccountSubHead = params['accountSubHead'];      
    });
    if (this.AccountHead!= null && this.AccountSubHead != null && this.mode!=null) 
    {
      this.GetAccountSubHeadByAccountHeadAndAccountSubHead(this.AccountHead, this.AccountSubHead);
    }
    if (this.mode == 'edit')
    {
      this.title = "Edit Account Sub Head";
    }
    if (this.mode == 'view')
    {
      this.title = "View Account Sub Head";
    }
    this.GetAllAccountHeads();
  }

  Reset(accountSubHeadForm)
  {
    accountSubHeadForm.reset();
  }
  keyPressText(event: any) {    
    const pattern =/[A-Za-z]/;
    let inputChar = String.fromCharCode(event.charCode);
    var uname = new String(event.target.value)
    if (!pattern.test(inputChar) && uname.trim().length==0)
    {
      event.preventDefault();
    }
 } 
  
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    // console.log(inputChar, e.charCode);
    let inputChars = new Number((event.target.value + inputChar).substring(0,12));
    var element1 = <HTMLDivElement> document.getElementById("div1");
    if (inputChars==0)
    {
      //swal("Warning!","Coming Here");
      element1.innerText="Please enter valid Account Sub Head";
      this.formSubmitted=true;
    }
    else
    {
      element1.innerText="";
    }
       if (!pattern.test(inputChar)) {
       // invalid character, prevent input
           event.preventDefault();
      }
 }
  GetAllAccountHeads()
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllAccountHeadValues()
    .subscribe(
      (data) => {
        this.accountHeads = data;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  GetAccountSubHeadByAccountHeadAndAccountSubHead(AccountHead, AccountSubHead)
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAccountSubHeadByAccountHeadAndAccountSubHead(this.AccountHead, this.AccountSubHead)
    .subscribe(
      (data) => {
        this.AccountSubHeadDetails = data;
        console.log("AccountSubHead");
        console.log(this.AccountSubHeadDetails);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  } 

  UpdateAccountSubHead(form)
  {
    var accountSubHeadText = <HTMLInputElement>document.getElementById("txtSubHeadName")
    let inputChars = new Number(accountSubHeadText.value);
    var element1 = <HTMLDivElement> document.getElementById("div1");
    if (inputChars==0)
    {      
      element1.innerText="Please enter valid Account Sub Head";
      form.invalid=true;
    }
    else
    {
      element1.innerText="";
    }
      if (!(form.invalid))
      {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.updateAccountSubHead(this.AccountSubHeadDetails).subscribe(
        (data:any) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('','Account Sub Head Updated Successfully!','success');
          this.router.navigate(['/home/subhead']);
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
        });
      }
      else
      {
        this.formSubmitted = true;
      }
  }
  Save(form)
  { 
    var accountSubHeadText = <HTMLInputElement>document.getElementById("txtSubHeadName")
    let inputChars = new Number(accountSubHeadText.value);
    var element1 = <HTMLDivElement> document.getElementById("div1");
    if (inputChars==0)
    {      
      element1.innerText="Please enter valid Account Sub Head";
      form.invalid=true;
    }
    else
    {
      element1.innerText="";
    }
    if (!(form.invalid))
    {
     document.getElementById('loader-spinner').style.display = "block";
        this.userService.addAccountSubHead(this.AccountSubHeadDetails).subscribe(
        (data:any) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('','Account sub head Added Successfully!','success');
          this.router.navigate(['/home/subhead']);
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
        });
      }
      else
      {
        this.formSubmitted = true;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/Finance/sub-head/sub-head.component.ts